<template>
  <el-dialog
    :model-value="visible"
    :before-close="() => {
      emit('close');
    }"
    align-center
    width="480"
  >
    <template #header>
      <div class="my-header">
        <h4 class="px-2 pb-3 text-xl text-[#344767] font-semibold">
          修改支付手机号
        </h4>
      </div>
    </template>

    <div class="px-2">
      <div class="text-[#6b7891] text-sm pb-[8px]">
        现支付手机号
      </div>

      <div class="custom-input-wrapper disabled pl-4">
        <input
          type="text"
          :value="phone"
          placeholder="请输入手机号"
          disabled
        >
      </div>

      <div class="text-[#6b7891] text-sm pb-[8px]">
        新手机号
      </div>

      <div
        class="custom-input-wrapper pl-4"
        :class="{ 'custom-field-error': errors.newPhone }"
      >
        <input
          type="text"
          :value="formState.newPhone"
          placeholder="请输入11位手机号码"
          @change="onNewPhoneChange"
          @keyup.enter="onConfirm"
        >
        <span class="custom-field-error-span">{{ errors.newPhone }}</span>
      </div>
    </div>

    <template #footer>
      <div class="flex justify-end px-[8px]">
        <el-button @click="emit('close')">
          取消
        </el-button>
        <el-button type="primary" :loading="loading" @click="onConfirm">
          确定
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import type { IUpdateUserPhoneParam } from '@core/main/types';
import { checkPhone } from '@core/tools';
import { SliderVerify, SmsButton } from '@vue3/components';
import { ElMessage } from 'element-plus';
import { reactive, ref, watchEffect } from 'vue';

const emit = defineEmits(['close', 'confirm']);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  phone: {
    type: String,
    default: '',
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const formState = reactive({ newPhone: '' });

const errors = reactive({ newPhone: '' });

const sliderRef = ref<InstanceType<typeof SliderVerify>>(null);
const smsBtnRef = ref<InstanceType<typeof SmsButton>>(null);
const newPhoneSmsBtnRef = ref<InstanceType<typeof SmsButton>>(null);

const onConfirm = () => {
  if (errors.newPhone) return;
  if (!formState.newPhone) return ElMessage.error('请输入新手机号');

  emit('confirm', JSON.parse(JSON.stringify(formState)) as IUpdateUserPhoneParam);
};

function onNewPhoneChange(e: Event) {
  const target = e.target as HTMLInputElement;
  const err = checkPhone(target.value);

  errors.newPhone = err;
  formState.newPhone = target.value;
}

watchEffect(() => {
  if (props.visible) {
    formState.newPhone = '';
    errors.newPhone = '';
    smsBtnRef.value?.hideLoading();
    newPhoneSmsBtnRef.value?.hideLoading();
    sliderRef.value?.reset();
  }
});
</script>
